import { useEffect } from 'react'
import * as Stats from '../stats'

export default function useTrackViewAnonymous(code: string) {
  useEffect(() => {
    Stats.trackAnonymous(code)
  }, [code])
}
